// extracted by mini-css-extract-plugin
export default {"header":"PeopleList_header__WMU1-","peopleList":"PeopleList_peopleList__tcvIx"};